import Icon from '~/src/common/components/Icon';
import Link from '~/src/common/components/Link';
import Sticker from '~/src/common/components/Sticker';
import I18n from '~/src/common/services/I18n';
import { ImageParams } from '~/src/common/typings/image';
import { getImageUrl } from '~/src/common/utils/cloudinary';

import SubCategoryList from '../SubCategories/SubCategories';
import { useNavigationTracking } from '../tracking';
import type * as T from '../types';

import styles from './CategoryItem.module.scss';

interface Props {
  category: T.Category;
}

const CategoryItem = ({ category }: Props) => {
  const { id, name, slug, children, label } = category;
  const image = getImageUrl(category.image, ImageParams.familyCategory);
  const { onClickCategoryName, onClickCategorySeeAll } = useNavigationTracking().large;

  return (
    <div className={styles.container}>
      <Link
        href={`/categorie/${slug}`}
        onClick={() => onClickCategoryName(id)}
        className={styles.head}>
        <img
          src={getImageUrl(image, ImageParams.familyCategory)}
          alt={name}
          className={styles.image}
        />
        <strong className={styles.name}>{name}</strong>
        {label && (
          <Sticker bg={label.bg} fg={label.fg}>
            {label.text}
          </Sticker>
        )}
      </Link>
      <SubCategoryList category={category} subcats={children} />
      <Link
        href={`/categorie/${slug}`}
        onClick={() => onClickCategorySeeAll(id)}
        className={styles.more}>
        <span>{I18n.t('common.see-all')}</span>
        <Icon name="chevron-right" size={16} />
      </Link>
    </div>
  );
};

export default CategoryItem;
